<template>
  <div
    class="border-0"
    @click="resetall"
  >
    <h2>
      My Folders and Groups
      <span
        @click="setvisible"
      >
        <fa-icon
          :name="visible ? 'chevron-up' : 'chevron-down'"
          class="mx-2"
          aria-controls="myfolderscollapse"
        />
      </span>
      <!-- <PopupBubble
        v-if="screentexts[2] && screentexts[2].element_bubbletext != '' && screentexts[2].element_bubbletext !== null"
        element_id="create-new-survey"
        :screen_id="screen_id"
        screenelement_id="2"
        :bubbletext="screentexts[2]?screentexts[2].element_bubbletext:''"
      /> -->
    </h2>
    <b-collapse
      id="myfolderscollapse"
      v-model="visible"
      class="mt-2"
    >
      <b-card class="border-0 my-0 py-0">
        <b-form
          inline
          @submit.prevent="nullfunction"
        >
          <sl-vue-tree
            ref="folderTree"
            v-model="nodes"
            class="col-12 col-lg-10 col-xl-8 px-0 mx-0"
            :allow-multiselect="allowmultiselect"
            @nodeclick="toggleExpand"
            @drop="nodeDropped"
            @beforedrop="checkDrop"
          >
            <template
              slot="toggle"
              slot-scope="{ node }"
            >
              <span v-if="node.data.gdqtype==3 || node.data.gdqtype==0">
                <fa-icon
                  v-if="!node.isExpanded && node.children.length > 0 && node.data.folder_id != 0"
                  name="caret-right"
                />
                <fa-icon
                  v-if="node.isExpanded && node.children.length > 0 && node.data.folder_id != 0"
                  name="caret-down"
                />
                <span
                  v-if="node.children.length == 0 || node.data.folder_id == 0"
                  class="sl-vue-tree-toggle"
                />
              </span>
            <!-- span v-if="node.data.gdqtype == 1">
              <span v-if="node.data.group_deleted == 0" class="sl-vue-tree-toggle">A</span>
            </span -->
            </template>
            <template
              slot="title"
              slot-scope="{ node }"
            >
              <span
                v-if="node.data.gdqtype==1"
                style="width: 16px;display: inline-block;"
              >&nbsp;</span>
              <span class="item-icon">
                <fa-icon
                  v-if="node.data.gdqtype == 0 && node.data.folder_id != 0"
                  name="folder"
                  :class="(node.data.group_deleted == 1) && muteclass"
                />
                <fa-icon
                  v-if="node.data.gdqtype == 0 && node.data.folder_id == 0"
                  name="user"
                />
                <fa-icon
                  v-if="node.data.gdqtype == 1"
                  name="users"
                  :class="(node.data.group_deleted == 1) && muteclass"
                />
                <fa-icon
                  v-if="node.data.gdqtype == 3"
                  name="trash-alt"
                />
                <fa-icon
                  v-if="node.data.gdqtype == 4"
                  name="folder"
                  class="text-primary"
                />
              </span>
              <!-- Type 0 = Folder -->
              <span
                v-if="node.data.gdqtype == 0"
                class="item-text"
                :class="(node.data.group_deleted == 1) && muteclass"
              >
                <span
                  v-if="editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id"
                >
                  {{ node.title }}
                </span>
                <b-form-input
                  v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id"
                  :ref="'f'+node.data.folder_id"
                  v-model="editingnodename"
                  class="item-input pb-0 pt-0 mt-0 mb-0"
                  placeholder="Type new name"
                  @keydown.esc="resetEditNode"
                  @keydown.enter.prevent="saveEditNode"
                />
              </span>
              <!-- Type 1 = Group -->
              <span
                v-if="node.data.gdqtype == 1"
                class="item-text"
                :class="(node.data.group_deleted == 1) && muteclass"
              >
                <span
                  v-if="editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id"
                >
                  {{ node.title }}
                </span>
                <b-form-input
                  v-if="editingnode != null && editingnode.data.folder_id == node.data.folder_id && editingnode.data.group_id == node.data.group_id"
                  :ref="'g'+node.data.group_id"
                  v-model="editingnodename"
                  class="item-input pb-0 pt-0 mt-0 mb-0"
                  placeholder="Type new name"
                  @keydown.esc="resetEditNode"
                  @keydown.enter.prevent="saveEditNode"
                />
              </span>
              <!-- Type 3 = Trash -->
              <span
                v-if="node.data.gdqtype == 3"
                class="item-text"
              >
                {{ node.title }}
              </span>
            <!-- Type 4 = Add new folder -->
            <!-- Type 5 - No folder -->
            </template>
            <template
              slot="sidebar"
              slot-scope="{ node }"
            >
              <span
                v-if="(node.data.gdqtype == 0 || node.data.gdqtype == 1) && (editingnode == null || editingnode.data.folder_id != node.data.folder_id || editingnode.data.group_id != node.data.group_id) && node.isSelected == true"
                class="float-right"
              >
                <span
                  v-if="node.data.gdqtype != 0 || node.data.folder_id != 0"
                  class="mr-4"
                  @click.prevent.stop="editNode"
                >
                  <fa-icon name="edit" />
                </span>
                <span
                  v-if="node.data.group_deleted == 0 && (node.data.gdqtype == 1 || node.data.folder_id != 0)"
                  class="mr-4"
                  @click.prevent="removeNode"
                >
                  <fa-icon name="trash-alt" />
                </span>
                <span
                  v-if="node.data.gdqtype == 1 && node.data.group_deleted == 0"
                  class="mr-4"
                  @click.prevent="group_setcurrent(node.data.group_id)"
                >
                  <fa-icon name="users" />
                </span>
                <span
                  v-if="node.data.gdqtype == 0 && node.data.group_deleted == 0 && editingnode == null"
                  class="mr-4"
                  @click.prevent.stop="addNode(node)"
                >
                  <fa-icon name="folder-plus" />
                </span>
                <input
                  v-if="addingnodeto==node"
                  ref="addingnodeinput"
                  v-model="addingnodename"
                  class="form-control col-3 col-sm-5 mr-2"
                  @click.prevent.stop="nullfalse"
                  @keydown.esc="resetAddNode"
                  @keydown.enter.prevent="saveAddNode"
                >
              </span>
            </template>
          </sl-vue-tree>
        </b-form>
      </b-card>
    </b-collapse>
  </div>
</template>
<script>
import PopupBubble from './PopupBubble'

export default {
  name: 'Folders',
  components: {
    // PopupBubble
  },
  data: function () {
    return {
      allowmultiselect: false,
      addingfolder: false,
      newfoldername: '',
      muteclass: 'text-muted',
      editingnode: null,
      editingnodename: '',
      addingnodeto: null,
      addingnodename: '',
      screen_id: 1,
      screentexts: [],
      visible: this.$store.state.mypage_folders_open
    }
  },
  computed: {
    nodes: {
      get () {
        var items = this.$store.state.foldertree
        return items
      },
      set () {
        return true
      }
    }
  },
  created () {
    this.groups_get()
    this.screentexts_get()
  },
  methods: {
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setfoldersopen', this.visible)
    },
    nullfunction: function () {
      return true
    },
    nullfalse: function () {
      return false
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    resetall () {
      this.addingnodeto = null
      this.editingnode = null
    },
    addNode (node) {
      var folderTree = this.$refs.folderTree
      var selected = document.getElementsByClassName('sl-vue-tree-selected')
      this.addingnodeto = node
      this.$nextTick(() =>
        this.$refs.addingnodeinput.focus())
    },
    resetAddNode () {
      this.addingnodeto = null
    },
    saveAddNode () {
      var folderTree = this.$refs.folderTree
      var parent = this.addingnodeto
      var newfolder = {
        folder_name: this.addingnodename,
        parent_id: parent.data.folder_id
      }
      this.addingnodename = ''
      this.$store.dispatch('folder_create', { folder: newfolder })
        .then(() => {
          this.$store.dispatch('foldertree_fetch', { type: 'old', drag: 1 })
            .then(() => {
              var thisnode = this.addingnodeto
              this.resetAddNode()
              folderTree.select(thisnode.path)
              this.$nextTick(() => folderTree.updateNode(thisnode.path, { isExpanded: true }))
            })
        })
    },
    editNode () {
      event.preventDefault()
      this.addingnode = null
      this.editingnode = null
      var folderTree = this.$refs.folderTree
      folderTree.traverse((node, nodeModel, path) => {
        if (node.isSelected == true) {
          this.editingnode = node
          this.editingnodename = node.title
          if (node.data.gdqtype == 0) {
            this.$nextTick(() => this.$refs['f' + node.data.folder_id].focus())
          }
          if (node.data.gdqtype == 1) {
            this.$nextTick(() => this.$refs['g' + node.data.group_id].focus())
          }
        }
      })
    },
    saveEditNode () {
      var folderTree = this.$refs.folderTree
      var node = this.editingnode
      if (node.data.gdqtype == 0) {
        var folder = {
          id: node.data.folder_id,
          folder_name: this.editingnodename
        }
        this.$store.dispatch('folder_save', { folder: folder })
          .then(() => {
            this.editingnode = null
            this.editingnodename = ''
            this.$store.dispatch('foldertree_fetch', { type: 'old', drag: 1 })
              .then(() => {
                folderTree.select(node.path)
                folderTree.updateNode(node.path, { isExpanded: true })
                return false
              })
          })
      }
      if (node.data.gdqtype == 1) {
        var group = {
          id: node.data.group_id,
          group_name: this.editingnodename
        }
        this.$store.dispatch('group_save', { group: group })
          .then((resp) => {
            this.editingnode = null
            this.editingnodename = ''
            this.$store.dispatch('foldertree_fetch', { type: 'old', drag: 1 })
              .then(() => {
                this.$store.dispatch('mygdqpage_setreload', { reload: 1 })
                  .then(() => {
                    folderTree.select(node.path)
                    return false
                  })
              })
          })
      }
    },
    resetEditNode () {
      this.editingnode = null
      this.editingnodename = ''
    },
    removeNode () {
      var thisnode = null
      var folderTree = this.$refs.folderTree
      folderTree.traverse((node, nodeModel, path) => {
        if (node.isSelected == true) {
          thisnode = node
        }
      })
      var group = {
        id: thisnode.data.group_id,
        group_folder_id: -1,
        group_deleted: 1
      }
      var folder = {
        id: thisnode.data.folder_id,
        parent_id: -1,
        folder_deleted: 1
      }
      var body = {
        group: group,
        folder: folder,
        type: thisnode.data.gdqtype
      }
      var id = 0
      if (thisnode.data.gdqtype == 0) { id = thisnode.data.folder_id }
      if (thisnode.data.gdqtype == 1) { id = thisnode.data.group_id }

      this.$store.dispatch('treeitem_save', { id: id, body: body })
        .then(() => {
          this.$store.dispatch('foldertree_fetch', { type: 'old', drag: 1 })
            .then(() => {
              //          folderTree.select(node.path);
              return false
            })
        })
    },
    toggleExpand (selectednode, event) {
      if (this.addingnodeto == null && this.editingnode == null) {
        var folderTree = this.$refs.folderTree
        // ----------------------
        // Folder, toggle expand
        // ----------------------
        if (selectednode.data.gdqtype == 0 || selectednode.data.gdqtype == 3) {
          folderTree.traverse((node, nodeModel, path) => {
            if (node.data.folder_id == selectednode.data.folder_id) {
              if (node.data.folder_id != 0) {
                var expand = !(node.isExpanded)
                folderTree.updateNode(node.path, { isExpanded: expand })
              }
            }
          })
        }
      }
      this.addingnodeto = null
    },
    checkDrop (dragginNodes, position, cancel) {
      if (position.node.data.gdqtype == 1 || position.node.data.gdqtype == 4) {
        cancel(true)
      }
    },
    nodeDropped (draggingNodes, position, event) {
      var gdqtype = draggingNodes[0].data.gdqtype
      var group_id = draggingNodes[0].data.group_id
      var folder_id = draggingNodes[0].data.folder_id
      var to_folder_id = position.node.data.folder_id
      var group_deleted = position.node.data.gdqtype == 3 ? 1 : 0
      var folder_deleted = position.node.data.gdqtype == 3 ? 1 : 0
      var group = {
        id: group_id,
        group_folder_id: to_folder_id,
        group_deleted: group_deleted
      }
      var folder = {
        id: folder_id,
        parent_id: to_folder_id,
        folder_deleted: folder_deleted
      }
      var body = {
        group: group,
        folder: folder,
        type: gdqtype
      }
      var id = 0
      if (gdqtype == 0) { id = folder_id }
      if (gdqtype == 1) { id = group_id }

      this.$store.dispatch('treeitem_save', { id: id, body: body })
        .then(() => {
          this.$store.dispatch('foldertree_fetch', { type: 'old', drag: 1 })
        })
    },
    groups_get: function () {
      this.$store.dispatch('foldertree_fetch', { type: 'old', drag: 1 })
      console.log(this.nodes)
    },
    group_setcurrent: function (group_id) {
      this.$store.dispatch('group_setcurrent', group_id)
      this.$router.push('/group')
    },
    opengroup: function (node, event) {
    }
  }
}
</script>
<style>
  .item-icon {
    display: inline-block;
    /* width: 30px; */
    margin-right: 4px;
    font-size: 1.1em !important;
  }
  .item-text {
    font-size: 1em !important;
  }
  .item-input {
    font-size: 1em !important;
  }
</style>
